import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth, axiosInstanceAuthForm } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  ConfigSetting: [],
  isSuccess: false,
  message: null,
  status: "idle", // idle | loading | succeeded | failed
  error: null,
};

export const fetchConfigSetting = createAsyncThunk("/ConfigSetting/Get", async () => {
  const response = await axiosInstanceAuth.get(`/Business/GetConfigSetting`);
  return response.data;
});

export const addOrUpdateConfigSetting = createAsyncThunk("/ConfigSetting/AddOrUpdate", async obj => {
  const response = await axiosInstanceAuthForm.post(`/Business/AddUpdateConfigSetting`, obj);
  return response.data;
});

export const updateConfigSettingStatus = createAsyncThunk("/ConfigSetting/StatusUpdate", async data => {
  const response = await axiosInstanceAuth.post(`/Business/configsettingstatusupdate`, {
    id: data?.ConfigSettingId,
    isActive: data?.IsActive,
  });
  return response.data;
});


const ConfigSettingSlice = createSlice({
  name: "ConfigSetting",
  initialState,
  reducers: {
    resetConfigState: state => {
      state.ConfigSetting = [];
      state.isSuccess = false;
      state.message = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)

      .addCase(fetchConfigSetting.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchConfigSetting.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.ConfigSetting = action.payload.Data;
      })
      .addCase(fetchConfigSetting.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(addOrUpdateConfigSetting.pending, state => {
        state.status = "loading";
      })
      .addCase(addOrUpdateConfigSetting.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;

        if (action.payload.Data) {
          state.ConfigSetting = action.payload.Data;
        }
      })
      .addCase(addOrUpdateConfigSetting.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(updateConfigSettingStatus.pending, state => {
        state.status = "loading";
      })
      .addCase(updateConfigSettingStatus.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;

        // Optional: update that record’s IsActive in your state
        if (action.payload.IsSuccess && state.ConfigSetting.length > 0) {
          const updatedId = action.meta.arg.ConfigSettingId;
          const index = state.ConfigSetting.findIndex(c => c.ConfigSettingId === updatedId);
          if (index !== -1) {
            state.ConfigSetting[index].IsActive = action.meta.arg.IsActive;
          }
        }
      })
      .addCase(updateConfigSettingStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });

  },
});

export const getConfigSettingDetails = state => state.ConfigSetting;

export const { resetConfigState } = ConfigSettingSlice.actions;

export default ConfigSettingSlice.reducer;
